import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/core/services/AuthService';
import { LanguageService } from 'src/core/services/language.service';
import { ProfileService } from 'src/core/services/ProfileService';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShellComponent implements OnInit {
    lang = localStorage.getItem('language');

    constructor(
        public languageService: LanguageService,
        public http: HttpClient,
        public auth: AuthService,
        public profileService: ProfileService) {
        // document.body.classList.add('menu-expanded');router: Router,
        // router.events.subscribe(event => {
        //     if (event instanceof NavigationEnd) {
        //         this.showWrapper = !['/chat'].filter(a => event.url === a).length;
        //     }
        // });
    }

    ngOnInit() {
        (window as any).initApp();
    }

    changeLang(lang: 'en' | 'ar'): void {
        if (this.languageService.current !== lang) {
            this.languageService.use(lang);

            // Angular 10: reload required for LOCALE_ID
            window.location.reload();
        }
    }

    onScroll(ev) {
        // if (ev.srcElement.scrollTop > 91) {
        //     document.body.classList.add('show-sticky-toolbar');
        // }
        // else {
        //     document.body.classList.remove('show-sticky-toolbar');
        // }
    }
}
